import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PartnerSignupService } from './partner-signup.service';

@Component({
  selector: 'app-partner-apply-snip',
  templateUrl: './partner-apply-snip.component.html',
  styleUrls: ['./partner-apply-snip.component.scss'],
})
export class PartnerApplySnipComponent implements OnInit {
  constructor(private partnerService: PartnerSignupService) {}

  @Input() product: string = 'ZeroPay';

  @Input() inputStyle: 'fill' | 'outline' | 'standard' = 'fill';
  @Input() buttonColor!: string;
  @Input() buttonTextColor!: string;

  @Input() formDesc1: string =
    'Thanks for your interest! Please fill the information below to sign up.';

  public entityTypes!: { label: string; value: any }[];
  public storePlatforms!: { label: string; value: any }[];
  @Output() submitEvent = new EventEmitter<any>();

  public form = new FormGroup({
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    emailAddress: new FormControl(null, [
      Validators.required,
      Validators.email,
    ]),
    mobileNumber: new FormControl(null, [Validators.required]),
    registeredName: new FormControl(null, [Validators.required]),
    registrationNumber: new FormControl(null, [Validators.required]),
    entityType: new FormControl(null, [Validators.required]),
    storeWebAddress: new FormControl(null, [Validators.required]),
    eCommercePlatform: new FormControl(null, [Validators.required]),
    noPhysicalStores: new FormControl(null),
    avgBasketSize: new FormControl(null, [Validators.required]),
    antCreditSales: new FormControl(null, [Validators.required]),
    accountNumber: new FormControl(null),
    branchCode: new FormControl(null),
    accountHolder: new FormControl(null),
    idDocument: new FormControl(null),
    bankStatement: new FormControl(null),
    recaptcha: new FormControl(null, [Validators.required]),
  });

  async ngOnInit(): Promise<void> {
    this.entityTypes = await this.partnerService.getCompanyEntities();
    this.storePlatforms = await this.partnerService.getECommercePlatforms();
  }

  async submit(form: FormGroup) {
    if (form.valid) {
      this.form.patchValue(form.value);
      this.submitEvent.emit(this.form.value);
    }
  }
}
